import { useProtectionProducts } from "./useProtectionProducts";

export function useProtectionProduct(type) {
  const protectionProducts = useProtectionProducts()

  if (!protectionProducts || !type) return null

  return type === "None" ? null : protectionProducts[type];
} 